"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("utils/constants");
const rfidLogColumnProps = [
    {
        show: true,
        field: 'dumptruck_no',
        title: 'DT / Hauler No',
        width: 'auto',
        filter: 'text',
        sortable: false,
    },
    {
        show: true,
        field: 'contractor_name',
        title: 'Contractor',
        width: 'auto',
        filter: 'text',
        sortable: false,
    },
    {
        show: true,
        field: 'rfid_tag',
        title: 'Tag',
        width: 'auto',
        sortable: false,
        filterable: false
    },
    {
        show: true,
        field: 'scan_date',
        title: 'Scan Date Time',
        width: 'auto',
        filter: 'date',
        sortable: false,
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`
    }
];
exports.default = rfidLogColumnProps;
